"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiPickerPreview = EmojiPickerPreview;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function EmojiPreview(_ref) {
  var emoji = _ref.emoji;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex h-20 items-center border-t border-muted p-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center justify-center text-2xl",
      children: emoji === null || emoji === void 0 ? void 0 : emoji.skins[0].native
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "overflow-hidden pl-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "truncate text-sm",
        children: emoji === null || emoji === void 0 ? void 0 : emoji.name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "truncate text-xs",
        children: ":".concat(emoji === null || emoji === void 0 ? void 0 : emoji.id, ":")
      })]
    })]
  });
}
function NoEmoji(_ref2) {
  var i18n = _ref2.i18n;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex h-20 items-center border-t border-muted p-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center justify-center text-2xl",
      children: "\uD83D\uDE22"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "overflow-hidden pl-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "truncate text-sm font-semibold text-primary",
        children: i18n.searchNoResultsTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "truncate text-xs",
        children: i18n.searchNoResultsSubtitle
      })]
    })]
  });
}
function PickAnEmoji(_ref3) {
  var i18n = _ref3.i18n;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex h-20 items-center border-t border-muted p-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center justify-center text-2xl",
      children: "\u261D\uFE0F"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "overflow-hidden pl-2",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "truncate text-sm font-semibold",
        children: i18n.pick
      })
    })]
  });
}
function EmojiPickerPreview(_ref4) {
  var emoji = _ref4.emoji,
    _ref4$hasFound = _ref4.hasFound,
    hasFound = _ref4$hasFound === void 0 ? true : _ref4$hasFound,
    i18n = _ref4.i18n,
    _ref4$isSearching = _ref4.isSearching,
    isSearching = _ref4$isSearching === void 0 ? false : _ref4$isSearching,
    props = _objectWithoutProperties(_ref4, ["emoji", "hasFound", "i18n", "isSearching"]);
  var showPickEmoji = !emoji && !(isSearching && !hasFound);
  var showNoEmoji = isSearching && !hasFound;
  var showPreview = !!emoji;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [showPreview && /*#__PURE__*/(0, _jsxRuntime.jsx)(EmojiPreview, _objectSpread({
      emoji: emoji
    }, props)), showPickEmoji && /*#__PURE__*/(0, _jsxRuntime.jsx)(PickAnEmoji, _objectSpread({
      i18n: i18n
    }, props)), showNoEmoji && /*#__PURE__*/(0, _jsxRuntime.jsx)(NoEmoji, _objectSpread({
      i18n: i18n
    }, props))]
  });
}